import { useState, type FormEvent } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Brasao } from "../../components/Layout";
import { api, type ErroApi } from "../../lib/api";

export function RedefinirSenha() {
  const { token = "" } = useParams();
  const [senha, setSenha] = useState("");
  const [confirmacao, setConfirmacao] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [feito, setFeito] = useState(false);
  const navigate = useNavigate();

  async function enviar(ev: FormEvent) {
    ev.preventDefault();
    setErro(null);
    if (senha.length < 8) { setErro("A senha deve ter pelo menos 8 caracteres."); return; }
    if (senha !== confirmacao) { setErro("As senhas não conferem."); return; }

    setEnviando(true);
    try {
      await api.post("/api/publico/candidatos/redefinir-senha", { token, senhaNova: senha });
      setFeito(true);
    } catch (e) {
      const err = e as ErroApi;
      setErro(err.motivos[0] ?? err.mensagem);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="tema-candidato tc-entrada">
      <div className="tc-entrada-corpo">
        <div className="tc-entrada-caixa">
          <div className="linha" style={{ justifyContent: "center", marginBottom: 8 }}>
            <Brasao tamanho={32} />
          </div>

          {feito ? (
            <div className="tc-cartao">
              <h1 className="tc-titulo">Senha redefinida</h1>
              <p className="tc-ajuda">Sua senha foi alterada. Entre com ela agora.</p>
              <button type="button" className="tc-btn tc-btn-primario tc-btn-largo"
                      onClick={() => navigate("/entrar")}>
                Ir para o login
              </button>
            </div>
          ) : (
            <form onSubmit={enviar} className="tc-cartao" noValidate>
              <h1 className="tc-titulo">Definir nova senha</h1>

              {erro && <div className="tc-erro" role="alert">{erro}</div>}

              <div className="tc-campo">
                <label htmlFor="senha">Nova senha</label>
                <input id="senha" type="password" value={senha} required minLength={8}
                       autoComplete="new-password" onChange={(e) => setSenha(e.target.value)} />
              </div>
              <div className="tc-campo">
                <label htmlFor="confirmacao">Confirme a senha</label>
                <input id="confirmacao" type="password" value={confirmacao} required
                       autoComplete="new-password" onChange={(e) => setConfirmacao(e.target.value)} />
              </div>

              <button type="submit" className="tc-btn tc-btn-primario tc-btn-largo" disabled={enviando}>
                {enviando ? "Salvando..." : "Salvar nova senha"}
              </button>
            </form>
          )}

          <div className="tc-links">
            <Link to="/entrar">Voltar para o login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
